import { createContext } from 'react';

export interface UploadProgressSnapshot {
  readonly totalFiles: number;
  readonly uploadedFiles: number;
  readonly currentFileName: string | null;
  readonly currentFileProgress: number | null;
}

export interface UploadProgressOperation {
  setTotalFiles(totalFiles: number): void;
  startFile(fileName: string): void;
  setFileProgress(progress: number | null): void;
  completeFile(): void;
  finish(): void;
}

export interface UploadProgressContextValue {
  readonly progress: UploadProgressSnapshot | null;
  beginUpload(totalFiles: number): UploadProgressOperation | null;
}

export const UploadProgressContext = createContext<UploadProgressContextValue | null>(null);
